import { DataTableQueryContextProvider } from "@/components/data-table/DataTableQueryContext";
import { RowSelectionProvider } from "@/components/data-table/context/RowSelectionProvider";
import { List } from "@/components/list/List";
import PageHeader from "@/components/PageHeader";
import { ContractorsPlannedHoursWizardTabs } from "@/modules/contractorsPlannedHoursWizard/components/ContractorsPlannedHoursWizardTabs";
import { useContractorsPlannedHoursWizardBreadcrumbItems } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardBreadcrumbItems";
import { useContractorsPlannedHoursWizardColumnOverrides } from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardColumnOverrides";
import {
  CONTRACTORS_PLANNED_HOURS_WIZARD_ALLOCATIONS_TABLE,
  useContractorsPlannedHoursWizardQuery,
} from "@/modules/contractorsPlannedHoursWizard/hooks/useContractorsPlannedHoursWizardQuery";
import { displayContractorsPlannedHoursWizardAllocation } from "@/schemas/contractorsPlannedHoursWizard";
import { DataTableFeatures } from "@/types/dataTableSettings";
import { DisplayContractorsPlannedHoursWizardAllocation } from "@/types/contractorsPlannedHoursWizard";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ContractorsPlannedHoursWizardDirectory = () => {
  const { t } = useTranslation();
  const breadcrumbItems = useContractorsPlannedHoursWizardBreadcrumbItems();
  const { query, options } = useContractorsPlannedHoursWizardQuery();
  const columnOverrides = useContractorsPlannedHoursWizardColumnOverrides();

  const allocationsTableFeatures = useMemo<DataTableFeatures>(
    () => ({
      enableRowSelection: true,
      enableSelectAll: true,
    }),
    [],
  );

  const queryValue = useMemo(() => ({ query }), [query]);

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <PageHeader
        breadcrumbItems={breadcrumbItems}
        title={t("contractorsPlannedHoursWizard.title")}
      />
      <RowSelectionProvider>
        <List<DisplayContractorsPlannedHoursWizardAllocation>
          schema={displayContractorsPlannedHoursWizardAllocation}
          name={CONTRACTORS_PLANNED_HOURS_WIZARD_ALLOCATIONS_TABLE}
          translationKey="contractorsPlannedHoursWizard"
          query={query}
          options={options}
          tableFeatures={allocationsTableFeatures}
          columnOverrides={columnOverrides}
        >
          <DataTableQueryContextProvider value={queryValue}>
            <ContractorsPlannedHoursWizardTabs />
          </DataTableQueryContextProvider>
        </List>
      </RowSelectionProvider>
    </div>
  );
};
